import React from 'react';
import './BranchAddresses.css';

const BranchAddresses = () => {
  return (
    <section id="branch-addresses" className="branch-addresses">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Sacred Locations</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Visit us at our divine consultation centers</p>
        </div>
        <div className="branches-grid">
          <div className="branch-card">
            <div className="branch-header">
              <div className="branch-icon">
                <i className="fas fa-moon"></i>
              </div>
              <div className="branch-status">
                <span className="status-badge city-center">Main Branch</span>
              </div>
            </div>
            <h3>Ahmedabad</h3>
            <div className="branch-address">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <p>Money Plant High Street, SG Highway<br />
                Ahmedabad, Gujarat 382470<br />
                India</p>
                <a href="https://www.google.com/maps/search/?api=1&query=Money+Plant+High+Street+SG+Highway+Ahmedabad+Gujarat+382470" target="_blank" rel="noopener noreferrer" className="map-link">
                  <i className="fas fa-external-link-alt"></i> Open in Google Maps
                </a>
              </div>
            </div>
            <div className="branch-details">
              <div className="branch-timing">
                <i className="fas fa-clock"></i>
                <span>Mon-Sat: 9AM-9PM | Sun: By appointment only</span>
              </div>
              <div className="branch-services">
                <i className="fas fa-crystal-ball"></i>
                <span>All Services Available</span>
              </div>
            </div>
          </div>
          <div className="branch-card">
            <div className="branch-header">
              <div className="branch-icon">
                <i className="fas fa-star-of-david"></i>
              </div>
              <div className="branch-status">
                <span className="status-badge main-office">Sub Branch</span>
              </div>
            </div>
            <h3>Gandhinagar</h3>
            <div className="branch-address">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <p>Plot no 6,1st floor<br /> Indradhanush-2 Kudasan
                    <br />Nr. Podar International School<br />
                Gandhinagar, Gujarat 382421<br />
                India</p>
                <a href="https://www.google.com/maps/search/?api=1&query=Plot+no+6+1st+floor+Indradhanush-2+Kudasan+Nr+Podar+International+School+Gandhinagar+Gujarat+382421" target="_blank" rel="noopener noreferrer" className="map-link">
                  <i className="fas fa-external-link-alt"></i> Open in Google Maps
                </a>
              </div>
            </div>
            <div className="branch-details">
              <div className="branch-timing">
                <i className="fas fa-clock"></i>
                <span>Mon-Sat: 9AM-9PM | Sun: By appointment only</span>
              </div>
              <div className="branch-services">
                <i className="fas fa-crystal-ball"></i>
                <span>All Services Available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BranchAddresses;